import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { captureError } from "@/lib/sentry";

const ErrorFallback = ({ error }) => (
  <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
    <div style={{ maxWidth: 520, fontFamily: "system-ui, sans-serif" }}>
      <h1 style={{ fontSize: 22, marginBottom: 8 }}>Something went wrong</h1>
      <p style={{ color: "#555", marginBottom: 12 }}>
        The frontend hit a runtime error while loading.
      </p>
      {error?.message && (
        <pre style={{ whiteSpace: "pre-wrap", background: "#f4f4f5", padding: 12, borderRadius: 8 }}>
          {error.message}
        </pre>
      )}
    </div>
  </div>
);

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    captureError(error, {
      action: "react_render_error",
      componentStack: errorInfo?.componentStack,
    });
  }

  render() {
    if (this.state.error) {
      return <ErrorFallback error={this.state.error} />;
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
